import { VALIDATING_TELEPHONY, REDUCERS } from '../../constants.js';

const validatingInitialState = {
  reducer_type : REDUCERS.REDUCER_ACTIOS_FROM_SM,
  currentState : VALIDATING_TELEPHONY.VALIDATING,
  time : 0
}

const validatingTelephonyState = (state = validatingInitialState, action) => {
  switch (action.type) {
    case VALIDATING_TELEPHONY.VALIDATING:
      return { currentState : VALIDATING_TELEPHONY.VALIDATING, time : action.time};
    case VALIDATING_TELEPHONY.VALID:
      return { currentState : VALIDATING_TELEPHONY.VALID, time : 0 };
    case VALIDATING_TELEPHONY.ERROR:
      return { currentState : VALIDATING_TELEPHONY.ERROR, time : 0 };
    default:
      return state;
  }
}

export default validatingTelephonyState;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_validating_telephony.js